var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-main", staticStyle: { "padding-bottom": "40px" } },
    [
      _c("div", {
        staticClass: "contract-box",
        domProps: { innerHTML: _vm._s(_vm.artcCntnt) }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "spaceCenter" },
        [
          _c(
            "a-button",
            {
              staticClass: "btn-blue-line",
              staticStyle: { margin: "30px 0" },
              on: {
                click: function($event) {
                  return _vm.goBack()
                }
              }
            },
            [_vm._v("返回")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-574f88f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-574f88f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/financing-page/contract-detail.vue
// module id = ACUt
// module chunks = 1